<template>
  <div data-v-63c64df2="" data-v-2ac6a5fc="" class="deposit-container">
    <div data-v-63c64df2="" class="cardgroup">
      <div data-v-63c64df2="" class="channels">
        <div data-v-63c64df2="" @click="changType(0)" :class="type == 0 ? 'channel active' : 'channel'">
          <div data-v-63c64df2="" class="title">虚拟币取款</div>
          <div data-v-63c64df2="" class="border"></div>
        </div>
        <div data-v-63c64df2="" @click="changType(1)" :class="type == 1 ? 'channel active' : 'channel'">
          <div data-v-63c64df2="" class="title">人民币取款</div>
          <div data-v-63c64df2="" class="border"></div>
        </div>
      </div>
    </div>
    <div data-v-a3842dac="" data-v-63c64df2="" class="deposit" v-if="type == 0">
      <div data-v-a3842dac="" class="low-special">
        <div data-v-a3842dac="" class="deposit-title">提现到</div>

        <div data-v-a3842dac="">
          <div data-v-a3842dac="">
            <div data-v-a3842dac="" @click="changBankId(item.id)" v-for="(item, index) in usdssLis" :key="index" :class="bankId == item.id ? 'deposit-bq yesBorder' : 'deposit-bq noBorder'">
              <div data-v-a3842dac="" class="deposit-item active">
                <div data-v-a3842dac="" class="deposit-info">
                  <img data-v-a3842dac="" class="icon" src="/static/image/usdt.png" alt="" />

                  <span data-v-a3842dac="">
                    {{ item.bank_owner }}<br data-v-a3842dac="" />
                    <span data-v-a3842dac="" class="subText"> {{ item.bank_no }}</span></span
                  >
                </div>
              </div>
            </div>
            <div data-v-a3842dac="" class="deposit-bq noBorder" @click="openUsdt" v-if="usdssLis.length < 6">
              <div data-v-a3842dac="" class="deposit-item active">
                <div data-v-a3842dac="" class="deposit-info">
                  <img
                    data-v-a3842dac=""
                    class="icon"
                    src="data:image/png;base64,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"
                    alt=""
                  />
                  <span data-v-a3842dac="">
                    添加取款方式<br data-v-a3842dac="" />
                    <span data-v-a3842dac="" class="subText">添加USDT地址</span></span
                  >
                </div>
              </div>
            </div>
          </div>
 <div data-v-a3842dac="" class="deposit-title">打码量</div>
          <div data-v-a3842dac="" class="amount-wrap">
            <input data-v-a3842dac="" placeholder="打码量" v-model="betAmount" type="text" disabled maxlength="17" class="amount-input" />
            <div data-v-a3842dac="" class="amount-unit">CNY</div>
          </div>
          <div data-v-a3842dac="" class="deposit-title">金额</div>
          <div data-v-a3842dac="" class="amount-wrap">
            <input data-v-a3842dac="" placeholder="请输入转账金额" v-model="amount" type="text" maxlength="17" class="amount-input" />
            <div data-v-a3842dac="" class="amount-unit">CNY</div>
          </div>
        </div>
        <div data-v-a3842dac="" class="deposit-title">支付密码</div>
        <div data-v-a3842dac="" class="amount-wrap">
          <input data-v-a3842dac="" placeholder="请输入支付密码" v-model="password" autocomplete="new-password" type="password" maxlength="17" class="amount-input" />
        </div>
        <div data-v-a3842dac="" class="deposit-title" v-if="chanmeyXi">
          手续费
          <span style="font-size: 12px; color: #ccc">
            {{ chanmeyXi == 'ERC20' ? $store.state.userInfo.withdrawcashfee : $store.state.userInfo.withdrawfeeusdttrc }}
          </span>
        </div>

        <div data-v-a3842dac="" class="deposit-title">
          USDT换算: &nbsp;&nbsp;&nbsp;&nbsp;<span style="font-size: 12px; color: #ccc">
            {{ amount ? Math.floor((amount / $store.state.userInfo.withdrawusdtrate) * 100) / 100 : '0.00' }}
            &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;参考汇率：{{ $store.state.userInfo.withdrawusdtrate }}
          </span>
        </div>

        <div data-v-a3842dac="" class="deposit-title">
          实际到账：&nbsp;&nbsp;&nbsp;&nbsp;
          <span style="font-size: 12px; color: #ccc">
            {{ amount ? Math.floor((amount / $store.state.userInfo.withdrawusdtrate) * 100) / 100 - (chanmeyXi == 'ERC20' ? $store.state.userInfo.withdrawcashfee * 1 : $store.state.userInfo.withdrawfeeusdttrc * 1) : '0.00' }}
          </span>
        </div>

        <div data-v-a3842dac="" class="wxsm-tips">
          <i data-v-a3842dac=""></i>
          <div data-v-a3842dac="">温馨提示：如有疑问请联系客服 <span data-v-a3842dac="" @click="$parent.openKefu()">联系客服</span></div>
        </div>
        <div data-v-a3842dac="" class="low-special-btn" @click="withdraw">确定</div>
        <div style="height: 88px"></div>
      </div>
      <div data-v-5742baa6="" data-v-71669d2d="" class="dialog" v-if="showUsdt">
        <div data-v-5742baa6="" class="dialog-cover back"></div>
        <div data-v-5742baa6="" class="dialog-content">
          <div data-v-71669d2d="" class="side">
            <div data-v-71669d2d="" class="side__header"><span data-v-71669d2d="">添加USDT地址</span><a data-v-71669d2d="" href="javascript:void 0;" class="side__close" @click="openUsdt"></a></div>
            <div data-v-71669d2d="" class="side__content">
              <div data-v-71669d2d="" class="gold">
                <img data-v-71669d2d="" src="payInfo.cardlist.payimg" alt="" class="gold__img" />
                <div data-v-71669d2d="" class="gold__amount" style="display: flex; align-items: center">
                  <span data-v-71669d2d=""> USDT地址 </span>
                  <input type="text" v-model="usdss"  oninput="value=value.replace(/[\W]/g,'')" class="meinput gold__amount-number" />
                </div>
                <div data-v-71669d2d="" class="gold__amount" style="display: flex; align-items: center">
                  <span data-v-71669d2d=""> 钱包协议 </span>
                  <div class="meinput gold__amount-number" style="display: flex; align-items: center; margin-left: 30px">
                    <span @click="changmeyXi('ERC20')" :class="meyXi == 'ERC20' ? 'types active' : 'types'">ERC20</span>
                    <span @click="changmeyXi('TRC20')" :class="meyXi == 'TRC20' ? 'types active' : 'types'">TRC20</span>
                  </div>
                </div>
                <div data-v-71669d2d="" class="gold__amount" style="display: flex; align-items: center"><span data-v-71669d2d=""> 支付密码 </span><input v-model="pay_pass" type="password" class="meinput gold__amount-number" /></div>

                <button data-v-71669d2d="" class="scan__button" @click="bindUsdss">确认添加</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div data-v-a3842dac="" data-v-63c64df2="" class="deposit" v-if="type == 1">
      <div data-v-a3842dac="" class="low-special">
        <div data-v-a3842dac="" class="deposit-title">提现到</div>

        <div data-v-a3842dac="">
          <div data-v-a3842dac="">
            <div data-v-a3842dac="" @click="changBankId(item.id)" v-for="(item, index) in cardLis" :key="index" :class="bankId == item.id ? 'deposit-bq yesBorder' : 'deposit-bq noBorder'">
              <div data-v-a3842dac="" class="deposit-item active">
                <div data-v-a3842dac="" class="deposit-info">
                  <img data-v-a3842dac="" class="icon" :src="item.ico" alt="" />

                  <span data-v-a3842dac="">
                    {{ item.bank }}---{{ item.bank_owner }}<br data-v-a3842dac="" />
                    <span data-v-a3842dac="" class="subText"> {{ item.bank_no }}</span></span
                  >
                </div>
              </div>
            </div>
            <div data-v-a3842dac="" class="deposit-bq noBorder" @click="$parent.goNav('/addBankCard')" v-if="cardLis.length < 6">
              <div data-v-a3842dac="" class="deposit-item active">
                <div data-v-a3842dac="" class="deposit-info">
                  <img
                    data-v-a3842dac=""
                    class="icon"
                    src="data:image/png;base64,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"
                    alt=""
                  />
                  <span data-v-a3842dac="">
                    添加取款方式<br data-v-a3842dac="" />
                    <span data-v-a3842dac="" class="subText">添加银行卡</span></span
                  >
                </div>
              </div>
            </div>
          </div>
          <div data-v-a3842dac="" class="deposit-title">打码量</div>
          <div data-v-a3842dac="" class="amount-wrap">
            <input data-v-a3842dac="" placeholder="打码量" v-model="betAmount" type="text" disabled maxlength="17" class="amount-input" />
            <div data-v-a3842dac="" class="amount-unit">CNY</div>
          </div>
          <div data-v-a3842dac="" class="deposit-title">金额</div>
          <div data-v-a3842dac="" class="amount-wrap">
            <input data-v-a3842dac="" placeholder="请输入转账金额" v-model="amount" type="text" maxlength="17" class="amount-input" />
            <div data-v-a3842dac="" class="amount-unit">CNY</div>
          </div>
        </div>
        <div data-v-a3842dac="" class="deposit-title">支付密码</div>
        <div data-v-a3842dac="" class="amount-wrap">
          <input data-v-a3842dac="" placeholder="请输入支付密码" autocomplete="new-password" v-model="password" type="password" maxlength="17" class="amount-input" />
        </div>
        <div data-v-a3842dac="" class="wxsm-tips">
          <i data-v-a3842dac=""></i>
          <div data-v-a3842dac="">温馨提示：如有疑问请联系客服 <span data-v-a3842dac="" @click="$parent.openKefu()">联系客服</span></div>
        </div>
        <div data-v-a3842dac="" class="low-special-btn" @click="withdraw">确定</div>
        <div style="height: 88px"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'deposit',
  data() {
    return {
      type: 0,
      cardLis: [],
      usdssLis: [],
      amount: null,
      password: null,
      bankId: null,
      showUsdt: false,
      pay_pass: null,
      usdss: null,
      meyXi: 'ERC20', //qian
      chanmeyXi: null,
      betAmount: null,
    };
  },
  created() {
    let that = this;
    that.getBetAmount();

    that.getcard();
    that.getUsdssList();
    that.baseURL = sessionStorage.getItem('baseURL') || '';
  },
  methods: {
    getBetAmount() {
      let that = this;
      that.$apiFun
        .post('/api/getBetAmount', {})
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.betAmount = res.data.bet_amount;
          }
        })
        .catch(res => {});
    },
    changmeyXi(val) {
      this.meyXi = val;
    },
    bindUsdss() {
      let that = this;
      let usdss = that.usdss;
      let meyXi = that.meyXi;

      if (usdss == null || usdss == '') {
        that.$parent.showTost(0, '请输入USDT地址');
        return;
      }
      if (!meyXi) {
        that.$parent.showTost(0, '请选择钱包协议');
        return;
      }
      if (!that.pay_pass) {
        that.$parent.showTost(0, '请输入支付密码');
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/bindcard', { bank: 'USDT', bank_no: usdss, bank_owner: meyXi, pay_pass: that.pay_pass })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.$parent.showTost(1, '添加成功！');
            that.getUsdssList();
            that.openUsdt();
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    openUsdt() {
      this.showUsdt = !this.showUsdt;
      this.pay_pass = null;
      this.usdss = null;
    },
    changBankId(id) {
      let that = this;
      that.bankId = id;
      if (that.type == 0) {
        let chanmeyXi = null;
        that.usdssLis.forEach(el => {
          if (el.id == id) {
            chanmeyXi = el.bank_owner;
            return;
          }
        });
        that.chanmeyXi = chanmeyXi;
      } else {
        that.chanmeyXi = null;
      }
    },
    withdraw() {
      //  amount: "100"
      // bank: 163
      // bank_owner: "TRC20"
      // password: "1"
      let that = this;
      // amount	是	float	金额
      // bank	是	int	提现银行卡id
      let bank = that.bankId;
      let amount = that.amount;
      let password = that.password;
      if (!bank) {
        that.$parent.showTost(0, '您要提现到哪里呢？');
        return;
      }
      if (amount < 100) {
        that.$parent.showTost(0, '单笔取款不能低于100元');
        return;
      }

      if (!password) {
        that.$parent.showTost(0, '请输入您的支付密码');
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/withdraw', { amount, bank, password })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.$parent.showTost(1, '提交成功，等待后台审核');
            that.amount = null;
            that.password = null;
            that.bank = null;
            setTimeout(() => {
              that.$router.push({ path: '/assets?type=1' });
            }, 1500);
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },

    getUsdssList() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun.post('/api/getcard', { type: 2 }).then(res => {
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.usdssLis = res.data;
        }
        that.$parent.hideLoading();
      });
    },
    changType(val) {
      let that = this;
      if (that.type == val) {
        return;
      }
      that.type = val;
      that.amount = null;
      that.password = null;
      that.bankId = null;
    },
    getcard() {
      let that = this;
      // that.$parent.showLoading();
      that.$apiFun
        .post('/api/getcard', { type: 1 })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.cardLis = res.data;
          }
          // that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
@import '../../../static/css/chunk-7f0f3200.8064035a.css';
@import '../../../static/css/chunk-1b70332d.c584f871.css';
.types.active {
  background-image: -webkit-gradient(linear, left top, right top, from(rgb(254, 203, 77)), to(rgb(255, 223, 144)));
  background-image: linear-gradient(90deg, rgb(254, 203, 77), rgb(255, 223, 144));
  color: #fff;
}

.types {
  color: #482000;
  display: block;
  border-radius: 6px;
  text-align: center;
  padding: 2px 9px;
  font-size: 12px;
  margin-right: 10px;
  height: 20px;
  line-height: 20px;
}
.meinput {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 100%;
  background-color: transparent;
  border: none;
  outline: none;
  flex: 1;
  padding-left: 10px;
  font-size: 16px;
}
.subText {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 250px;
  display: block;
}
.lefts {
  display: flex;
  align-items: center;
}
.lefts img {
  width: 30px;
  margin-right: 30px;
}
.JoiHTIGs {
  display: flex;
  justify-items: center;
  flex-wrap: wrap;
}
._1lgxzaTd.VnPYo1MB {
  cursor: pointer;
}

.JoiHTIGs ._3jiVkBQ9 {
  // margin-right: 20px;
  margin-bottom: 20px;
}
._1lgxzaTd {
  width: 100%;
  height: 120px;
  position: relative;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 8px;
  padding: 12px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  background-image: url(/static/image/bg2.c14d2591.png);
}
.bottom-slide-enter-active[data-v-5742baa6],
.bottom-slide-leave-active[data-v-5742baa6] {
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
}
.bottom-slide-enter[data-v-5742baa6],
.bottom-slide-leave-to[data-v-5742baa6] {
  -webkit-transform: translateY(100%);
  transform: translateY(100%);
}
.dialog-content[data-v-5742baa6] {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 9950;
  width: 100%;
  height: auto;
}
.dialog-cover[data-v-5742baa6] {
  z-index: 9940;
}
.authorization[data-v-2b97710c],
.dialog-cover[data-v-5742baa6] {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}
.authorization[data-v-2b97710c] {
  z-index: 999999;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.authorization .content[data-v-2b97710c] {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  border-radius: 8px;
  background: #fff;
  width: 315px;
}
.authorization .content .close[data-v-2b97710c] {
  position: absolute;
  width: 20px;
  height: 20px;
  top: 15px;
  right: 15px;
  margin: auto;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAAEEfUpiAAAABGdBTUEAALGPC/xhBQAAAh5JREFUWAm1lYlxwjAQRTE0xEAVSbogKStJF5k0gQ0NgbN/46/RsbpM4hmQvMfbr5Vlb+Z5HjbxdT6fZ9g4qt+8CYwIC3iNN4qXvwS28BI7DGD7ji0pLDoMgy6CdpXmZziHTNR+uVyefaM/V984jh/4+Q7MqUftcZDvdK0mRcSejsfjNhFLLAMVLX9umcAiE444KBS0BDBIu2bVdAFY6+12+xJRnxL4ihK1C10XwD2IAxE6SQ6cyw330W9TEmeBSomuzzEJIPScdqsP8Lk2MxAjKjIZvYFtmqZ3jMWrJNVamoOVEl3QMklA2MZiV2NCBNoAAAWZuKyZee585rpsEbhDu93uxR3Z1mUkPUCF1iaayZRYgxSTa5Cm5ByklmxuH5Yjie64lo66eRbwwuIZgLLD4fBGhfFoAiBbVJwIgRqoipPN+3jNtd0JIHEynU2QXHITpJZchLQm5yB6Gkv7zER/RE+k8B2nceB3AQEAYc9lDL+yfvYDcxTGu1VGfVmrgNj4H0KKNbigYtDKjrQwk9PRkkTRubGHkQggtAfySE5WQA90jVjyqwIYmCsCv/j0qca89yQ1CwAclyUE9t7CyMHVJSBX/Be1TkSTAKswV4zi/ssF9/TJWH2hFQWUCsfwnliI5GUKWAsDtDc3ENCbzFVYYytLBbQGW4Vqtho7+BoC1vMA1Yr7fkuI+xper9cnBO/3++/44fIhfzGHEL/eD8H/cjgqcbjmAAAAAElFTkSuQmCC)
    no-repeat;
  background-size: 100% 100%;
}
.authorization .content .content-box[data-v-2b97710c] {
  padding: 40px 20px 20px;
}
.authorization .content .content-box .kyberbit[data-v-2b97710c] {
  height: 50px;
}
.authorization .content .content-box h3[data-v-2b97710c] {
  color: #333;
  font-size: 18px;
  margin-top: 3px;
  margin-bottom: 2px;
}
.authorization .content .content-box p[data-v-2b97710c] {
  color: #666;
  margin-top: 4px;
}
.authorization .content .content-box .logo-box[data-v-2b97710c] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-top: 16px;
  background: #eef0f5;
  padding: 15px;
  border-radius: 4px;
}
.authorization .content .content-box .logo-box img[data-v-2b97710c] {
  display: block;
  width: 50px;
  margin-right: 10px;
}
.authorization .content .content-box .logo-box span[data-v-2b97710c] {
  display: block;
  color: #333;
  margin-top: 5px;
}
.authorization .content .btn-box[data-v-2b97710c] {
  margin-top: 15px;
}
.authorization .content .btn-box .btn[data-v-2b97710c] {
  border-radius: 4px;
  color: #cca352;
  height: 45px;
  line-height: 45px;
  text-align: center;
}
.authorization .content .btn-box .btn.active[data-v-2b97710c] {
  background: #cca352;
  color: #fff;
}
.differentDepositTip[data-v-74a3466c] {
  width: 100%;
  padding: 0 0.13rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background-image: -webkit-gradient(linear, left top, right top, from(#fa471d), color-stop(52%, #8900d3), to(#60f));
  background-image: linear-gradient(90deg, #fa471d, #8900d3 52%, #60f);
}
.differentDepositTip .item[data-v-74a3466c] {
  width: 100%;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  height: 0.35rem;
}
.differentDepositTip .item .item-left[data-v-74a3466c],
.differentDepositTip .item[data-v-74a3466c] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.differentDepositTip .item .item-left[data-v-74a3466c] {
  font-size: 0.13rem;
  color: #fff;
  font-weight: 500;
}
.differentDepositTip .item .item-left img[data-v-74a3466c] {
  width: 0.16rem;
  height: 0.16rem;
}
.differentDepositTip .item .item-left span[data-v-74a3466c] {
  margin-left: 0.05rem;
}
.differentDepositTip .item .item-right[data-v-74a3466c] {
  font-size: 0.13rem;
  color: #fff;
  font-weight: 400;
  border: 1px solid #fff;
  border-radius: 4px;
  width: 0.6rem;
  height: 0.22rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.differentDepositTip .item .item-right img[data-v-74a3466c] {
  margin-left: 0.02rem;
  display: block;
  margin-top: 0.03rem;
}
.differentDepositTip.depositBottom[data-v-74a3466c] {
  background: #212121;
  border-radius: 0.04rem;
  margin-top: 0.1rem;
}
.differentDepositTip.depositBottom .item[data-v-74a3466c] {
  height: 0.4rem;
}
.differentDepositTip.depositBottom .item .item-left[data-v-74a3466c] {
  color: #ffcb4c;
}
.differentDepositTip.depositBottom .item .item-left img[data-v-74a3466c] {
  width: 0.26rem;
  height: 0.22rem;
  margin-top: 0.06rem;
}
.differentDepositTip.depositBottom .item .item-left span[data-v-74a3466c] {
  margin-left: 0;
}
.differentDepositTip.depositBottom .item .item-right[data-v-74a3466c] {
  border: none;
  color: #ffcb4c;
}
.differentDepositTip.depositSidBar[data-v-74a3466c] {
  background-image: -webkit-gradient(linear, left top, right top, color-stop(34%, #fa471d), to(#8b1ae5));
  background-image: linear-gradient(90deg, #fa471d 34%, #8b1ae5);
}
.protocolPopUp[data-v-26c8fc86] {
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}
.protocolPopUp .title[data-v-26c8fc86],
.protocolPopUp[data-v-26c8fc86] {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background: #fff;
}
.protocolPopUp .title[data-v-26c8fc86] {
  height: 0.4rem;
  font-size: 16px;
  color: #333 !important;
  font-weight: 600;
}
.protocolPopUp .title .close[data-v-26c8fc86] {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAAEgBckRAAAAAXNSR0IArs4c6QAAA6lJREFUaAXNWbtyFDEQvLXhUyD341dMQGQHRPA5OCKAiID7FduXw6eA65hWbcvSrB6jB3Vc1dVIo5nuaUmr3b3b7Uqfh4eHYzge9dmhDQN3RWc0GHUEQ/c97OFweLM7Ho+v8KVXon+w7QcjJ0fhDDOdn5ERLJ3M1IPSfymAQaEFgHxfpg4JcOhEHbiEKGgj4fHx8bc09/K9ub6+jmLOEBR+JPg7+ldXV+9hNSN87qOp6UdCVCqmHQ4G5CwTd26dclEJ/0J0LU7HIm5Zlm/Ojw4TdSD66/jL5gicGy3JYKJqplRwtChkIoDYvWh7F/TTTc0URm1WGsFARtDaDuPjtq65xJSeupVlw6SRY16/Dm7KudLV2SDLgr30/Pz8E6iypV/L8v/RDK19AceuuEGeW7fgInNYvUQhsAA5ldHG6CVKAbtKqYAdWitRCZhYkQI6aXNEFmBiFAkYpIlWf3UnIW5z6RA0tDw4Q5+0b0CsfJtuUUFuKrSi0q5LEuSAdXkWoojACtxC5Ah6gU1ECBICd4eQubzTST19Tp0cO/cuv/XeZiElJk9H5Jj2dQ2c1SPu/Pz87Zm/ecq+XteihpEdD8ERdHFx8WvaImtwXht+m47spBw4VHgCdHpISuAbglaSGniSwEpiAc8S1Eis4EWCHEkLeJUgRSI+97SAMW5FtHOfaBflgtTucmEWcASa7mgC5l4BggL21uenqgI95yGJ5Vm3qECDY1qEwD3qijWdXVkFKXBOi1qT4imcJCiBc4qsJBsCC3gLSUTQAm4l8QQ94BYSRzACXiNZZoCXSMKbvulsIVjOhruLN3337GI9W3LA9OPq5oOEv+nL0/NnmaqPCMLg5eXlB15UTDy1xVI+PT19EXuLWqS+e5mUT9FLpipyj0P01ELWPYjfdfxtiHViicOrIBkkwScRUio8rMmfE1BlTULsv/q01hAJYFGtIMwbsb2cSQEspBeU+RY7ylEUwAJGSYgT2lmYJgEknkE6A4P1wDYJYGJPET055CvZLgEEtBSF2PVnps05LkPDR/SQAKMQhoV2uHCCTRFAsMqKIGxa4eScJsBQPDmnihgWUCncv8Kx+sBOEdItoFZ4+CDYEhsINDWbBYwUM5KbU2MWMJN8JlZVwEwyPYszsLMCZoDrgnP9Ea6NgBGwXIFWfw+3F9CTbC2sNa6lFidAnlW+StJtgmjKWZ3ANblKQvDjgxzVd7mX+pMWrtXlhOCl3sfi7yH+ReSd/2FD1/kXqyYUaF3HgagAAAAASUVORK5CYII=)
    no-repeat;
  background-size: 100% 100%;
  width: 0.12rem;
  height: 0.12rem;
  position: absolute;
  top: 0.15rem;
  right: 0.15rem;
}
.protocolPopUp .content[data-v-26c8fc86] {
  overflow: hidden;
  width: 100%;
  height: calc(100% - 0.4rem);
  overflow-y: auto;
}
.protocolPopUp .content img[data-v-26c8fc86] {
  max-width: 100%;
  height: auto;
  margin-top: 0.1rem;
}
.scan__qr img {
  width: 100%;
  height: 100%;
}
.mt125[data-v-71669d2d] {
  margin-top: 125px !important;
}
.c-yellow[data-v-71669d2d] {
  color: #cca352;
}
.protocol-box .sub-tips[data-v-71669d2d] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin: 0.2rem 0 0.1rem 0;
  font-size: 0.16rem;
  color: #fff;
}
.protocol-box .sub-tips img[data-v-71669d2d] {
  width: 0.14rem;
  height: 0.14rem;
  margin-left: 0.03rem;
}
.protocol-box .dcbox-protocol[data-v-71669d2d] {
  height: 45px;
  background: #282828;
  border-radius: 4px;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 0 0.55rem;
  margin-bottom: 0.15rem;
}
.protocol-box .dcbox-protocol .protocol-item[data-v-71669d2d],
.protocol-box .dcbox-protocol[data-v-71669d2d] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.protocol-box .dcbox-protocol .protocol-item .text[data-v-71669d2d] {
  font-size: 14px;
  color: #999;
  font-weight: 400;
}
.protocol-box .dcbox-protocol .protocol-item .circle[data-v-71669d2d] {
  width: 12px;
  height: 12px;
  border: 1px solid #999;
  border-radius: 50%;
  margin-right: 7px;
  position: relative;
}
.protocol-box .dcbox-protocol .protocol-item img[data-v-71669d2d] {
  width: 0.3rem;
  height: 0.16rem;
  margin-left: 0.05rem;
}
.protocol-box .dcbox-protocol .protocol-item.active .text[data-v-71669d2d] {
  font-size: 14px;
  color: #fff;
}
.protocol-box .dcbox-protocol .protocol-item.active .circle[data-v-71669d2d] {
  border: 1px solid #facb5c;
}
.protocol-box .dcbox-protocol .protocol-item.active .circle[data-v-71669d2d]:after {
  content: '';
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #facb5c;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
}
.deposit .deposit-input-title[data-v-71669d2d] {
  margin: 20px 0 0;
  font-size: 0.16rem;
  color: #fff;
}
.deposit__amount-input-wrapper[data-v-71669d2d] {
  position: relative;
  margin-top: 0.1rem;
  width: 100%;
  height: 0.5rem;
  background: #212121;
  border-radius: 0.04rem;
}
.deposit__amount-unit[data-v-71669d2d] {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  right: 0;
  width: 0.5rem;
  height: 0.5rem;
  background: #333;
  border-radius: 4px;
  font-size: 0.16rem;
  color: #999;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.deposit__amount-input[data-v-71669d2d] {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  font-size: 24px;
  line-height: 34px;
  color: #fff;
  background-color: transparent;
  border: none;
  outline: none;
  padding-left: 0.1rem;
}
.deposit__amount-input[data-v-71669d2d]::-webkit-input-placeholder {
  font-size: 16px;
  color: #666;
}
.deposit__amount-input[data-v-71669d2d]::-moz-placeholder {
  font-size: 16px;
  color: #666;
}
.deposit__amount-input[data-v-71669d2d]:-ms-input-placeholder {
  font-size: 16px;
  color: #666;
}
.deposit__amount-input[data-v-71669d2d]::-ms-input-placeholder {
  font-size: 16px;
  color: #666;
}
.deposit__amount-input[data-v-71669d2d]::placeholder {
  font-size: 16px;
  color: #666;
}
.deposit__cny-tips[data-v-71669d2d] {
  margin-top: 5px;
  font-size: 16px;
  line-height: 1;
  color: #999;
}
.deposit__content[data-v-71669d2d] {
  padding: 0 15px;
  overflow: hidden;
}
.deposit__title[data-v-71669d2d] {
  margin: 20px 0 15px;
  font-size: 16px;
  line-height: 18px;
  color: #fff;
}
.deposit__list[data-v-71669d2d] {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-left: 30px;
}
.deposit__item[data-v-71669d2d] {
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: inline-block;
  width: 33.33%;
  height: 80px;
  overflow: hidden;
  font-size: 14px;
  color: #fff;
  text-align: center;
  vertical-align: top;
  background-color: #333;
  border: 1px solid transparent;
  border-radius: 5px;
}
.deposit__item + .deposit__item[data-v-71669d2d] {
  margin-left: 15px;
}
.deposit__item[data-v-71669d2d]:nth-child(3n + 1) {
  margin-left: -30px;
}
.deposit__item[data-v-71669d2d]:nth-child(n + 4) {
  margin-top: 15px;
}
.deposit__item.active[data-v-71669d2d] {
  background-color: #282828;
  border: 1px solid #cca352;
}
.deposit__item.amount[data-v-71669d2d] {
  height: 50px;
  font-size: 16px;
  line-height: 50px;
  color: #ccc;
  border-radius: 4px;
}
.deposit .ylcb-tips[data-v-71669d2d] {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 14px;
  background: url(/static/image/bank_tips.bb95242e.png) no-repeat;
  background-size: 100% 100%;
}
.deposit__icon[data-v-71669d2d] {
  width: 30px;
  height: 30px;
  margin-top: 15px;
  margin-bottom: 5px;
  vertical-align: top;
}
.deposit__button[data-v-71669d2d] {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  height: 45px;
  margin-top: 40px;
  font-size: 18px;
  line-height: 45px;
  color: #fff;
  text-align: center;
  background-color: #cca352;
  border: none;
  border-radius: 4px;
  outline: none;
}
.side[data-v-71669d2d] {
  background-color: #fff;
  border-radius: 4px 4px 0 0;
}
.side__header[data-v-71669d2d] {
  position: relative;
  height: 48px;
  font-size: 18px;
  line-height: 48px;
  color: #333;
  text-align: center;
  border-bottom: 1px solid #f4f4f4;
}
.side__close[data-v-71669d2d] {
  position: absolute;
  top: 50%;
  right: 15px;
  width: 14px;
  height: 14px;
  margin-top: -7px;
  background: url(data:image/png;base64,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)
    no-repeat 50%;
}
.side__content[data-v-71669d2d] {
  min-height: 200px;
  max-height: 580px;
  padding: 0 15px;
  overflow: auto;
}
.gold[data-v-71669d2d],
.scan[data-v-71669d2d] {
  padding-bottom: 15px;
}
.gold__amount[data-v-71669d2d],
.scan__amount[data-v-71669d2d] {
  height: 54px;
  font-size: 16px;
  line-height: 54px;
  color: #666;
  border-bottom: 1px solid #ddd;
}
.gold__amount-number[data-v-71669d2d],
.scan__amount-number[data-v-71669d2d] {
  float: right;
  color: #333;
}
.gold__title[data-v-71669d2d],
.scan__title[data-v-71669d2d] {
  margin-top: 15px;
  font-size: 15px;
  line-height: 21px;
  color: #333;
  text-align: center;
}
.gold__subtitle[data-v-71669d2d],
.scan__subtitle[data-v-71669d2d] {
  font-size: 13px;
  line-height: 18px;
  color: #999;
  text-align: center;
}
.gold__crc[data-v-71669d2d],
.scan__crc[data-v-71669d2d] {
  font-size: 12px;
  color: #999;
  text-align: center;
  margin-bottom: -8px;
  margin-top: 5px;
}
.gold__qrwrap[data-v-71669d2d],
.scan__qrwrap[data-v-71669d2d] {
  position: absolute;
  width: 150px;
  height: 150px;
  margin-top: 15px;
  left: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}
.gold__qrwrap .crc2[data-v-71669d2d],
.scan__qrwrap .crc2[data-v-71669d2d] {
  position: absolute;
  opacity: 0.3;
  background: #000;
  right: 0;
  bottom: 9px;
  color: #fff;
  z-index: 2;
  font-size: 12px;
  padding: 2px 1px;
}
.gold__qr[data-v-71669d2d],
.scan__qr[data-v-71669d2d] {
  width: 150px;
  height: 150px;
  margin: 15px auto;
  font-size: 0;
}
.gold__qr img[data-v-71669d2d],
.scan__qr img[data-v-71669d2d] {
  width: 130px;
  height: 130px;
}
.gold__protocol[data-v-71669d2d],
.scan__protocol[data-v-71669d2d] {
  width: 1.5rem;
  height: 0.24rem;
  line-height: 0.24rem;
  background: #000;
  border-radius: 0.12rem;
  margin: 0 auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  color: #fff;
  letter-spacing: 0;
  font-weight: 500;
  font-size: 0.14rem;
  padding: 0 0.1rem;
}
.gold__protocol .ex-change[data-v-71669d2d],
.scan__protocol .ex-change[data-v-71669d2d] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #ffcb4c;
  font-weight: 400;
  margin-left: 0.05rem;
}
.gold__protocol .ex-change img[data-v-71669d2d],
.scan__protocol .ex-change img[data-v-71669d2d] {
  width: 0.12rem;
  height: 0.12rem;
  margin-left: 0.03rem;
}
.gold .small-gold[data-v-71669d2d],
.scan .small-gold[data-v-71669d2d] {
  margin-top: -0.1rem;
}
.gold .tip-list[data-v-71669d2d],
.scan .tip-list[data-v-71669d2d] {
  font-size: 0.12rem;
  color: #999;
  font-weight: 500;
  margin-top: 0.15rem;
}
.gold .tip-list span[data-v-71669d2d],
.scan .tip-list span[data-v-71669d2d] {
  color: #cca452;
}
.gold__link[data-v-71669d2d],
.scan__link[data-v-71669d2d] {
  position: relative;
  height: 35px;
  padding-right: 70px;
  margin-top: 5px;
  overflow: hidden;
  font-size: 14px;
  line-height: 35px;
  color: #333;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: #f5f5f5;
  border-radius: 4px;
}
.gold__copy[data-v-71669d2d],
.scan__copy[data-v-71669d2d] {
  position: absolute;
  top: 0;
  right: 0;
  width: 70px;
  height: 100%;
  color: #fff;
  text-align: center;
  background-color: #cca352;
  border-radius: 4px;
}
.gold__tips[data-v-71669d2d],
.scan__tips[data-v-71669d2d] {
  margin-top: 15px;
  font-size: 12px;
  line-height: 17px;
  color: #999;
}
.gold__button[data-v-71669d2d],
.scan__button[data-v-71669d2d] {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  height: 48px;
  margin-top: 20px;
  font-size: 18px;
  line-height: 48px;
  color: #fff;
  text-align: center;
  background-color: #cca352;
  border: none;
  border-radius: 4px;
  outline: none;
}
.scan[data-v-71669d2d] {
  position: relative;
}
.gold__img[data-v-71669d2d] {
  width: 100%;
  height: auto;
  margin-top: 20px;
  vertical-align: top;
}
.exchange[data-v-71669d2d] {
  padding-bottom: 15px;
  padding-left: 15px;
}
.exchange__item[data-v-71669d2d] {
  position: relative;
  display: inline-block;
  width: 50%;
  margin-top: 15px;
  overflow: hidden;
  text-align: center;
  vertical-align: top;
  background-color: #f5f5f5;
  border-radius: 6px;
}
.exchange__item[data-v-71669d2d]:nth-child(odd) {
  margin-right: 15px;
  margin-left: -15px;
}
.exchange__item .logo-link[data-v-71669d2d] {
  display: inline-block;
  width: 100%;
}
.exchange__icon[data-v-71669d2d] {
  width: 100%;
  height: 115px;
  vertical-align: top;
}
.exchange__link[data-v-71669d2d] {
  height: 36px;
  font-size: 14px;
  line-height: 36px;
  color: #333;
  background-color: #eee;
}
.exchange__icon-hot[data-v-71669d2d] {
  position: absolute;
  top: 0;
  right: 0;
  width: 48px;
  height: 24px;
  font-size: 14px;
  line-height: 24px;
  color: #fff;
  text-align: center;
  background: -webkit-gradient(linear, left top, right top, from(#2ee6c7), to(#4d88ff));
  background: linear-gradient(90deg, #2ee6c7, #4d88ff);
  border-radius: 0 6px 0 6px;
}
.banner-wrap[data-v-71669d2d] {
  width: 100%;
  position: absolute;
  bottom: 20px;
  padding: 0 15px;
}
.banner-wrap .page__banner[data-v-71669d2d] {
  position: relative;
}
.banner-wrap .page__banner-img[data-v-71669d2d] {
  width: 100%;
  height: auto;
  vertical-align: top;
}
.banner-wrap .page__text-button-guide[data-v-71669d2d] {
  z-index: 2;
  position: absolute;
  width: 88px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  color: #fff;
  border: 1px solid #fff;
  left: 50%;
  top: 34px;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
  border-radius: 15px;
}
.banner-wrap .page__text-button-reg[data-v-71669d2d] {
  position: absolute;
  left: 0;
  width: 40%;
  height: 100%;
}
.banner-wrap .page__text-button-reg .btn[data-v-71669d2d] {
  position: absolute;
  color: #fff;
  left: 20px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.banner-wrap .page__text-button-download[data-v-71669d2d] {
  position: absolute;
  right: 0;
  width: 40%;
  height: 100%;
}
.banner-wrap .page__text-button-download .btn[data-v-71669d2d] {
  position: absolute;
  color: #fff;
  right: 20px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.banner-wrap .page__full-tips[data-v-71669d2d] {
  height: 20px;
  font-size: 14px;
  line-height: 20px;
  color: #666;
  text-align: center;
}
.no-data-notice[data-v-71669d2d] {
  margin-top: 60px;
  text-align: center;
}
.guide[data-v-71669d2d] {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.8);
}
.guide__button[data-v-71669d2d] {
  position: absolute;
  left: 50%;
  bottom: 100px;
  width: 162px;
  padding: 5px 0;
  margin-left: -81px;
  font-size: 14px;
  color: #cca352;
  text-align: center;
  background-color: #000;
  border: 1px solid #996b3d;
  border-radius: 4px;
  outline: none;
}
.guide__title[data-v-71669d2d] {
  margin-top: 75px;
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
  color: #f3b663;
  text-align: center;
}
.guide__subtitle[data-v-71669d2d] {
  margin-top: 18px;
  font-size: 15px;
  line-height: 1;
  color: #fff;
  text-align: center;
}
.guide__subtitle + .guide__subtitle[data-v-71669d2d] {
  margin-top: 10px;
}
.guide__img[data-v-71669d2d] {
  width: 100%;
  height: auto;
}
.guide__cny-img[data-v-71669d2d] {
  width: 252px;
  height: auto;
  margin-top: 16px;
}
.guide__usdt-img[data-v-71669d2d] {
  width: 278px;
  height: auto;
  margin-top: 48px;
}
.guide__usdt-img.img1[data-v-71669d2d] {
  margin-top: 70px;
}
.guide__close[data-v-71669d2d] {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 20px;
  height: 20px;
}
.guide__cny-arrow[data-v-71669d2d] {
  position: absolute;
  bottom: 90px;
  left: 40px;
  width: auto;
  height: 150px;
}
.guide__usdt-arrow[data-v-71669d2d] {
  position: absolute;
  top: 42px;
  left: 76px;
  width: 35px;
  height: auto;
}
.guide__usdt-arrow1[data-v-71669d2d] {
  position: absolute;
  top: 128px;
  left: 76px;
  width: 78px;
  height: auto;
}
.kyberbit-guide-button[data-v-71669d2d] {
  position: fixed;
  right: 10px;
  bottom: 92px;
  z-index: 10;
  width: 50px;
  height: 50px;
  background-image: url(/static/image/btn-entrance.36d47e44.png);
  background-size: 100% 100%;
}
.showPopupTxt[data-v-71669d2d] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #cca352;
  text-decoration: underline;
  margin-top: 20px;
}
.protocolPopUp .title[data-v-26c8fc86][data-v-1b127c58] {
  height: 1.4rem;
  font-size: 16px;
  color: #333 !important;
  font-weight: 600;
}
.protocolPopUp .title .close[data-v-26c8fc86][data-v-1b127c58] {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAAEgBckRAAAAAXNSR0IArs4c6QAAA6lJREFUaAXNWbtyFDEQvLXhUyD341dMQGQHRPA5OCKAiID7FduXw6eA65hWbcvSrB6jB3Vc1dVIo5nuaUmr3b3b7Uqfh4eHYzge9dmhDQN3RWc0GHUEQ/c97OFweLM7Ho+v8KVXon+w7QcjJ0fhDDOdn5ERLJ3M1IPSfymAQaEFgHxfpg4JcOhEHbiEKGgj4fHx8bc09/K9ub6+jmLOEBR+JPg7+ldXV+9hNSN87qOp6UdCVCqmHQ4G5CwTd26dclEJ/0J0LU7HIm5Zlm/Ojw4TdSD66/jL5gicGy3JYKJqplRwtChkIoDYvWh7F/TTTc0URm1WGsFARtDaDuPjtq65xJSeupVlw6SRY16/Dm7KudLV2SDLgr30/Pz8E6iypV/L8v/RDK19AceuuEGeW7fgInNYvUQhsAA5ldHG6CVKAbtKqYAdWitRCZhYkQI6aXNEFmBiFAkYpIlWf3UnIW5z6RA0tDw4Q5+0b0CsfJtuUUFuKrSi0q5LEuSAdXkWoojACtxC5Ah6gU1ECBICd4eQubzTST19Tp0cO/cuv/XeZiElJk9H5Jj2dQ2c1SPu/Pz87Zm/ecq+XteihpEdD8ERdHFx8WvaImtwXht+m47spBw4VHgCdHpISuAbglaSGniSwEpiAc8S1Eis4EWCHEkLeJUgRSI+97SAMW5FtHOfaBflgtTucmEWcASa7mgC5l4BggL21uenqgI95yGJ5Vm3qECDY1qEwD3qijWdXVkFKXBOi1qT4imcJCiBc4qsJBsCC3gLSUTQAm4l8QQ94BYSRzACXiNZZoCXSMKbvulsIVjOhruLN3337GI9W3LA9OPq5oOEv+nL0/NnmaqPCMLg5eXlB15UTDy1xVI+PT19EXuLWqS+e5mUT9FLpipyj0P01ELWPYjfdfxtiHViicOrIBkkwScRUio8rMmfE1BlTULsv/q01hAJYFGtIMwbsb2cSQEspBeU+RY7ylEUwAJGSYgT2lmYJgEknkE6A4P1wDYJYGJPET055CvZLgEEtBSF2PVnps05LkPDR/SQAKMQhoV2uHCCTRFAsMqKIGxa4eScJsBQPDmnihgWUCncv8Kx+sBOEdItoFZ4+CDYEhsINDWbBYwUM5KbU2MWMJN8JlZVwEwyPYszsLMCZoDrgnP9Ea6NgBGwXIFWfw+3F9CTbC2sNa6lFidAnlW+StJtgmjKWZ3ANblKQvDjgxzVd7mX+pMWrtXlhOCl3sfi7yH+ReSd/2FD1/kXqyYUaF3HgagAAAAASUVORK5CYII=)
    no-repeat;
  background-size: 100% 100%;
  width: 0.42rem;
  height: 0.42rem;
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;
}
</style>



// WEBPACK FOOTER //
// src/components/main/withdraw.vue